<template>
  <v-layout row wrap pa-3>
    <v-flex xs12 md8 wrap>
      <v-layout column wrap main-section>
        <v-flex pt-3>
          <v-card-title>
            <v-icon>mdi-school</v-icon>
            <h4 class="headline halfwhite-text ml-2">Learn & Earn</h4>
          </v-card-title>
          <v-flex v-if="$store.getters.learnAndEarnEnabled" xs12 mt-3 ml-3>
            <LearnAndEarn></LearnAndEarn>
          </v-flex>
          <v-flex v-else xs12 mt-3 ml-3>
            <v-card color="white" class="rounded">
              <v-card-text>
                <div class="orange--text text--darken-4">
                  Learn & Earn is currently turned-off, please contact your org
                  admin.
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex></v-flex>
    <v-flex xs12 md3 px-3 mt-4 mr-2>
      <v-layout column wrap mt-4>
        <BalanceColumn></BalanceColumn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import BalanceColumn from "@/components/BalanceColumn";
import LearnAndEarn from "@/components/LearnAndEarn";

export default {
  name: "LearningBoard",
  components: { BalanceColumn, LearnAndEarn },
  data() {
    return {};
  },
};
</script>
